import { DebugToolbar } from "@/components/DebugToolbar/DebugToolbar";
import { Link } from "@tanstack/react-router";
import css from "./SiteFooter.module.scss";

export function SiteFooter() {
  return (
    <footer className={css.footer}>
      <div className="l-wrapper">
        <div className={css.content}>
          <Link className={css.homeLink} to="/">
            <img
              className={css.logoWide}
              src="/assets/logos/logo-white-horizontal-initials-wide.svg"
              alt="Alice & Bob"
            />
            <img
              className={css.logoNarrow}
              src="/assets/logos/logo-white-horizontal-initials-narrow.svg"
              alt="Alice & Bob"
            />
          </Link>

          <DebugToolbar />
        </div>
      </div>
    </footer>
  );
}
